import { css } from 'styled-components';

/** Shared mobile breakpoint for campaign UI — desktop styles stay the default above this width. */
export const CAMPAIGN_MOBILE_MAX = '768px';

export const campaignMobile = (...args: Parameters<typeof css>) => css`
  @media (max-width: ${CAMPAIGN_MOBILE_MAX}) {
    ${css(...args)}
  }
`;
